import { useSliderContext } from '@cian/slider';
import * as React from 'react';

import { Dot } from '../Dot';
import { useDots } from './hooks/useDots';
import * as styles from './PaginationDots.css';

export const PaginationDots: React.FC = () => {
  const { totalSlides, currentSlide } = useSliderContext();
  const { dotsConfig, translateX } = useDots(totalSlides, currentSlide);

  return (
    <div className={styles['container']}>
      <ul
        className={styles['scroller']}
        style={{
          transform: `translateX(${translateX}px)`,
        }}
      >
        {dotsConfig.map((c, i) => (
          <Dot key={`dot_${i}`} {...c} />
        ))}
      </ul>
    </div>
  );
};
